import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import ProfileHelpComp from "../../../components/sharedcomponents/ProfileHelpComp";

export const UserHelpCenterPage = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar
          showBackButton
          displayType="title"
          title="Help Center"
          showNotification
        ></TopBar>
        <ProfileHelpComp></ProfileHelpComp>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserHelpCenterPage;
